import React from 'react';

const useDocumentTitle = (title: string) => {
    React.useEffect(() => {
        document.title = title + ' - Vårdbemanning Sverige';
    }, [title]);
};

export default useDocumentTitle;
